import * as Yup from "yup";

export const AddProductsScheme = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  crmProductId: Yup.string().required("Crm Id is required"),
  minAmount: Yup.number()
    .typeError("Minimum Amount must be a number")
    .required("Minimum Amount is required"),
  heading_1: Yup.string().required("Heading one is required"),
  heading_2: Yup.string().required("Heading two is required"),
  heading_3: Yup.string().required("Heading three is required"),
  title_1: Yup.string().required("Title one is required"),
  title_2: Yup.string().required("Title two is required"),
  title_3: Yup.string().required("Title three is required"),
  zone: Yup.string().required("Zone is required"),
  image: Yup.string().required("Image is required"),
  // language: Yup.string().required("Please choose a language"),
  language: Yup.string()
    .notOneOf(["select"], "Please choose a language")
    .required("Please choose a language"),

  sort: Yup.number()
    .typeError("Sort must be a number")
    .required("Sort is required"),
});
